import React, { useState, useEffect } from 'react';


import * as Api from '../API/API.js';


function SensorsDashboard(props){

  const [dashboardLink, setDashboardLink] = useState("");

  useEffect(() => {
    Api.fetchSensorsLink().then(val => {
      if(val && val !== ""){
        setDashboardLink(val.dashboard_link);

      }
    }).catch(error =>{console.log("fetchSensorsLink - ERROR");
    });
    
  }, []);
     
    return(
        
      <div className="iframe sensorsdashboardiframe"><iframe src={dashboardLink}  width="100%" height="100%" title="Sensors Dashboard"></iframe></div>
    )
}

export default SensorsDashboard;